// paex-zone-promo.js — PE - Zone promo banner (Sasha 2026-10-22).
// Shows ONE banner block per visitor (sections/paex-zone-promo.liquid):
//   zone (paex:offer-change, assets/paex-shipping-offer.js) →
//     remote / none            → other
//     regional                 → regional
//     metro + next-day date    → next_day   (AfterShip earliest date = the
//                                            next business day after dispatch)
//     metro otherwise          → metro
//   Halloween clock verdict 'late' (paex:clock-change) → late (else other).
// Missing audience block → other → the first block. The pick is remembered
// (localStorage paex:zpb, 12 h) for the pre-paint reader in the section.
(function () {
  'use strict';

  var KEY = 'paex:zpb'; // read back for 12 h by the section's pre-paint script

  function init(root) {
    if (root.dataset.zpbReady) return;
    root.dataset.zpbReady = '1';
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-paex-zpb-config]').textContent); } catch (error) { cfg = {}; }
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-audience]'));
    if (!slides.length) return;

    var forced = null;
    try { forced = new URLSearchParams(location.search).get('zpb'); } catch (error) { forced = null; }

    var offer = window.paexShippingOffer ? window.paexShippingOffer.state : null;
    var clock = window.paexClock ? window.paexClock.state : null;
    var nextDay = {}; // postal -> true | false (pending = absent)
    var inflight = {};
    var waited = false;
    var hardWaited = false;
    var loaded = document.readyState === 'complete';

    function slideFor(audience) {
      var order = [audience, 'other'];
      for (var i = 0; i < order.length; i += 1) {
        for (var j = 0; j < slides.length; j += 1) {
          if (slides[j].dataset.audience === order[i]) return slides[j];
        }
      }
      return slides[0];
    }

    function show(audience, remember) {
      var target = slideFor(audience);
      var img = target.querySelector('img');
      if (img) img.loading = 'eager'; // the shown banner is above the fold; hidden ones stay lazy
      slides.forEach(function (slide) { slide.hidden = slide !== target; });
      if (root.getAttribute('data-shown') !== audience) {
        root.setAttribute('data-shown', audience);
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'paex_zone_banner', audience: audience });
      }
      if (remember && !forced) {
        try { localStorage.setItem(KEY, JSON.stringify({ a: audience, t: Date.now() })); } catch (error) { /* storage off */ }
      }
    }

    // the next business day after dispatch, in the warehouse calendar
    function nextDayKey() {
      if (typeof paexEddEstimate !== 'function' || !cfg.edd) return null;
      var base = paexEddEstimate('*', cfg.edd);
      if (!base || typeof paexEddArrivalFor !== 'function') return null;
      var parsed = paexEddParseConfig(cfg.edd);
      var arrival = paexEddArrivalFor(base.dispatchDate, 1, parsed);
      return paexEddKey(arrival.getUTCFullYear(), arrival.getUTCMonth() + 1, arrival.getUTCDate());
    }

    function checkNextDay(postal) {
      if (!cfg.live || !postal || postal in nextDay || inflight[postal]) return;
      if (typeof paexEddLiveFetchFull !== 'function') return;
      inflight[postal] = true;
      var proc = cfg.edd ? cfg.edd.processing : 0;
      paexEddLiveFetchFull(cfg.proxy || '/apps/paex-edd', postal, proc)
        .catch(function () { return null; })
        .then(function (result) {
          var key = nextDayKey();
          nextDay[postal] = Boolean(result && result.date && key && result.date <= key);
          inflight[postal] = false;
          decide();
        });
    }

    // returns the audience, or null while the inputs are still pending
    function audience() {
      if (forced) return forced;
      // the engine is a later defer script: missing before load = pending;
      // still missing after load = offer switched off → no zone promise
      if (!window.paexShippingOffer) return loaded || waited ? 'other' : null;
      var zone = offer && offer.zone;
      var source = offer && offer.source;
      if (!zone) {
        // the province can land before the postal (geo, then the IP backup)
        // no location yet: wait up to the hard cap (covers the 3.5 s IP backup
        // in paex-geotargetly.liquid) — first visits otherwise flip other → zone
        var located = window.paexGeo && window.paexGeo.postal;
        if (window.paexGeoUnknown !== true && !hardWaited && !located) return null;
        if (window.paexGeoUnknown !== true && !waited && (!source || source === 'none' || !offer.postal)) return null;
        return 'other';
      }
      var picked = 'other';
      if (zone === 'regional') picked = 'regional';
      if (zone === 'metro') {
        var postal = String(offer.postal || '').replace(/\s+/g, '').toUpperCase();
        // province guard (Sasha 2026-10-22): AfterShip predicts next-day for
        // Winnipeg / Moncton too — UPS never delivers there in one day
        var regions = String(cfg.nextDayRegions || '').split(/[\s,]+/).filter(Boolean);
        var region = String(offer.region || '').toUpperCase();
        if (!cfg.live || !/^[A-Z]\d[A-Z]/.test(postal) || regions.indexOf(region) === -1) picked = 'metro';
        else if (postal in nextDay) picked = nextDay[postal] ? 'next_day' : 'metro';
        else {
          checkNextDay(postal);
          if (!waited) return null;
          picked = 'metro'; // still waiting for the date: the safe promise
        }
      }
      // the clock's first verdict comes from the transit table and can flip to
      // on time once the live date lands — 'late' is trusted when live or after the wait
      if (clock && clock.verdict === 'late' && zone !== 'remote') {
        if (!(clock.estimate && clock.estimate.live) && !waited) return null;
        picked = 'late';
      }
      return picked;
    }

    function decide() {
      var picked = audience();
      if (picked) show(picked, true);
    }

    // the delivery-date helpers ship with the cart drawer / clock; load them
    // once if neither is on this page
    function ensureEdd() {
      if (!cfg.live || typeof paexEddLiveFetchFull === 'function' || !cfg.eddSrc) return;
      if (document.querySelector('script[src*="/paex-edd.js"]')) return;
      var tag = document.createElement('script');
      tag.src = cfg.eddSrc;
      tag.onload = decide;
      document.head.appendChild(tag);
    }

    document.addEventListener('paex:offer-change', function (event) { offer = event.detail; decide(); });
    document.addEventListener('paex:clock-change', function (event) { clock = event.detail; decide(); });
    document.addEventListener('paex:clock-ready', function (event) { clock = event.detail; decide(); });
    document.addEventListener('paex:geo-unknown', decide);
    window.addEventListener('load', function () { loaded = true; ensureEdd(); decide(); }, { once: true });

    setTimeout(function () {
      waited = true;
      decide();
    }, Number(cfg.wait) > 0 ? Number(cfg.wait) : 2000);
    setTimeout(function () {
      hardWaited = true;
      decide();
    }, Math.max(4500, Number(cfg.wait) || 0));

    // theme editor: the selected block shows; nothing is remembered
    if (cfg.editor) {
      forced = forced || (slides[0] && slides[0].dataset.audience);
      document.addEventListener('shopify:block:select', function (event) {
        var hit = slides.filter(function (slide) { return slide.contains(event.target) || slide === event.target; })[0];
        if (hit) { forced = hit.dataset.audience; show(forced, false); }
      });
    }

    decide();
  }

  document.querySelectorAll('[data-paex-zpb]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-paex-zpb]');
    if (root) init(root);
  });
})();
